/* eslint-disable no-shadow */
const state = () => ({
  initBranchLink: null,
});

// getters
const getters = {
};

  // actions
const actions = {
  initSession({ dispatch, commit }, { vueRouter }) {
    window.Branch.initSession().then((data) => {
      // If app opened from branch link
      if (data['+clicked_branch_link']) {
        commit('setBranchLink', data['~referring_link']);
      }

      // Handle deep link app path
      // eslint-disable-next-line dot-notation
      if (data && data['$deeplink_path'] && data['$deeplink_path'].trim().length > 0) {
        // eslint-disable-next-line dot-notation
        dispatch('handleDeepLinkPath', { vueRouter, deepLinkPath: data['$deeplink_path'] });
      }
      // window.Branch.getFirstReferringParams().then((res) => {
      //   console.log('getFIRSTReferringParams');
      //   console.log(res);
      // }).catch((err) => {
      //   console.log(err);
      // });
      // window.Branch.getLatestReferringParams().then((res) => {
      //   console.log('getLatestReferringParams');
      //   console.log(res);
      // }).catch((err) => {
      //   console.log(err);
      // });
    });
  },
  handleDeepLinkPath(context, { vueRouter, deepLinkPath }) {
    // Use JavaScript URL API to parse the URL
    const url = new URL(deepLinkPath);

    // Extract the path from the URL
    const path = url.pathname; // This will be "/register"

    // Extract the query parameters as an object
    const searchParams = new URLSearchParams(url.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    // Now, push it to the Vue router
    vueRouter.push({
      path,
      query: params,
    });
  },
};

  // mutations
const mutations = {
  setBranchLink(state, initBranchLink = null) {
    state.initBranchLink = initBranchLink;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/branch.js